<div class="user-data-container">
  <form [formGroup]="form">



<!--    <div class="user-dropdown-filter">-->
<!--      <input type="text"-->
<!--             placeholder="DJ type *"-->
<!--             aria-label="DJ type"-->
<!--             matInput-->
<!--             #tempInput="matAutocompleteTrigger"-->
<!--             formControlName="temps"-->
<!--             [matAutocomplete]="tempsEl">-->
<!--      <mat-autocomplete #tempsEl="matAutocomplete" [displayWith]="displayFn">-->
<!--        @for (option of tempsList; track option) {-->
<!--          <mat-option (click)="optionClicked($event, option)">-->
<!--            <div (click)="optionClicked($event, option)">-->
<!--              <mat-checkbox [checked]="option.selected" (change)="toggleSelection(option)" (click)="$event.stopPropagation()">-->
<!--                {{ option.name}}-->
<!--              </mat-checkbox>-->
<!--            </div>-->

<!--          </mat-option>-->
<!--        }-->
<!--      </mat-autocomplete>-->
<!--      <mat-icon class="open-trigger-icon" (click)="openPanel(tempInput)">arrow_drop_down</mat-icon>-->
<!--    </div>-->

<!--    <div class="custom-select">-->
<!--      <mat-select [formControl]="toppings" multiple>-->
<!--        @for (topping of toppingList; track topping) {-->
<!--          <mat-option [value]="topping">{{topping}}</mat-option>-->
<!--        }-->
<!--      </mat-select>-->
<!--    </div>-->




    <div class="pb-12">
      @if (showLabels()) {
        <div class="form-hint">First Name</div>
      }
      <div class="custom-icon-input-container">
        <input type="text" formControlName="firstName" placeholder="First Name *">
      </div>

      @if (form.controls.firstName.touched) {
        <div class="alert">

          @if (form.controls.firstName.hasError('required')) {
            <div class="form-validation-error">
              Required Field
            </div>
          }
        </div>
      }
    </div>

    <div class="pb-12">
      @if (showLabels()) {
        <div class="form-hint">Last Name</div>
      }
      <div class="custom-icon-input-container">
        <input type="text" formControlName="lastName" placeholder="Last Name *">
      </div>

      @if (form.controls.lastName.touched) {
        <div class="alert">

          @if (form.controls.lastName.hasError('required')) {
            <div class="form-validation-error">
              Required
            </div>
          }

        </div>
      }
    </div>

    <div class="pb-12">
      @if (showLabels()) {
        <div class="form-hint">Stage Name</div>
      }
      <div class="custom-icon-input-container">
        <input type="text" formControlName="stageName" placeholder="Stage Name *">
      </div>
      @if (form.controls.stageName.touched) {
        <div class="alert">

          @if (form.controls.stageName.hasError('required')) {
            <div class="form-validation-error">
              Required
            </div>
          }

        </div>
      }
    </div>
<!--    @if (showLabels()) {-->
<!--      <div class="form-hint">Stage Name(s)</div>-->
<!--    }-->
<!--    <div class="performance-locations pb-12">-->
<!--      <div class="performance-item" >-->
<!--        <div class="custom-icon-input-container">-->
<!--          <input type="text" formControlName="stageName" placeholder="Stage Name *">-->
<!--        </div>-->
<!--        @if (form.controls.stageName.touched) {-->
<!--          <div class="alert">-->

<!--            @if (form.controls.stageName.hasError('required')) {-->
<!--              <div class="form-validation-error">-->
<!--                Required-->
<!--              </div>-->
<!--            }-->

<!--          </div>-->
<!--        }-->
<!--      </div>-->
<!--      <div class="performance-item">-->
<!--        <div class="custom-icon-input-container">-->
<!--          <input type="text" formControlName="stageName2" placeholder="Stage name">-->
<!--        </div>-->
<!--      </div>-->
<!--      <div class="performance-item">-->
<!--        <div class="custom-icon-input-container">-->
<!--          <input type="text" formControlName="stageName3" placeholder="Stage name">-->
<!--        </div>-->
<!--      </div>-->
<!--    </div>-->


    <div class="pb-12">
      @if (showLabels()) {
        <div class="form-hint">DJ Type</div>
      }
      <div class="custom-select">
        <mat-select formControlName="performanceType" multiple placeholder="DJ types *">
          @for (type of performanceTypes(); track type) {
            <mat-option [value]="type">{{type}}</mat-option>
          }
        </mat-select>
      </div>
<!--      <div class="user-dropdown-filter">-->
<!--        <input type="text"-->
<!--               placeholder="DJ type *"-->
<!--               aria-label="DJ type"-->
<!--               matInput-->
<!--               #genresInput="matAutocompleteTrigger"-->
<!--               formControlName="performanceType"-->
<!--               [matAutocomplete]="typesEl">-->
<!--        <mat-autocomplete #typesEl="matAutocomplete">-->
<!--          @for (option of performanceTypes(); track option) {-->
<!--            <mat-option [value]="option">{{option}}</mat-option>-->
<!--          }-->
<!--        </mat-autocomplete>-->
<!--        <mat-icon class="open-trigger-icon" (click)="openPanel(genresInput)">keyboard_arrow_down</mat-icon>-->

<!--      </div>-->

      @if (form.controls.performanceType.touched) {
        <div class="alert">

          @if (form.controls.performanceType.hasError('required')) {
            <div class="form-validation-error">
              Required
            </div>
          }

        </div>
      }
    </div>

    <div class="form-hint">Where do you usually perform
      <span class="accent pointer" matTooltip="Venue / Station / Event" [matTooltipPosition]="'above'">?</span>
    </div>
    <div class="performance-locations pb-12">
      <div class="performance-item" >
        <div class="custom-icon-input-container">
          <input type="text" formControlName="performanceLocations1" placeholder="Location *">
        </div>
        @if (form.controls.performanceLocations1.touched) {
          <div class="alert">

            @if (form.controls.performanceLocations1.hasError('required')) {
              <div class="form-validation-error">
                Required
              </div>
            }

          </div>
        }
      </div>
      <div class="performance-item">
        <div class="custom-icon-input-container">
          <input type="text" formControlName="performanceLocations2" placeholder="Location">
        </div>
      </div>
      <div class="performance-item">
        <div class="custom-icon-input-container">
          <input type="text" formControlName="performanceLocations3" placeholder="Location">
        </div>
      </div>
    </div>

    <div class="pb-12">
      @if (showLabels()) {
        <div class="form-hint">Weekly performances</div>
      }
      <div class="custom-icon-input-container">
        <input type="number" formControlName="weeklyPerformances" min="1" placeholder="How Many People Do You Perform For Weekly *">
      </div>
      @if (form.controls.weeklyPerformances.touched) {
        <div class="alert">

          @if (form.controls.weeklyPerformances.hasError('required')) {
            <div class="form-validation-error">
              Required
            </div>
          }
          @if (form.controls.weeklyPerformances.hasError('min')) {
            <div class="form-validation-error">
              Should be positive number
            </div>
          }

        </div>
      }
    </div>


      <div class="pb-12">
        @if (showLabels()) {
          <div class="form-hint">Website</div>
        }
        <div class="custom-icon-input-container">
          <input type="text" formControlName="website" placeholder="Website *">
        </div>
        @if (form.controls.website.hasError('pattern')) {
          <div class="form-validation-error">
            Incorrect Url. Example: https://example.com/username or http://example.com?username=user
          </div>
        }
      </div>

      <div class="pb-12">
        @if (showLabels()) {
          <div class="form-hint">Instagram</div>
        }
        <div class="custom-icon-input-container">
          <input type="text" formControlName="instagram" placeholder="Instagram *">
        </div>
        @if (form.controls.instagram.hasError('pattern')) {
          <div class="form-validation-error">
            Should contain "." or "&#64;" symbols. Examples: .username or &#64;username &#64;user.name
          </div>
        }
      </div>


      <div class="pb-12">
        @if (showLabels()) {
          <div class="form-hint">Facebook</div>
        }
        <div class="custom-icon-input-container">
          <input type="text" formControlName="facebook" placeholder="Facebook *">
        </div>
        @if (form.controls.facebook.hasError('pattern')) {
          <div class="form-validation-error">
            Should contain "." or "&#64;" symbols. Examples: .username, &#64;username &#64;user.name
          </div>
        }
      </div>

    @if (form.controls.website.touched || form.controls.instagram.touched || form.controls.facebook.touched) {
      <div class="alert">

        @if (form.hasError('noSocials')) {
          <div class="form-validation-error">
            Specify at least one social link
          </div>
        }

      </div>
    }




  </form>

</div>
